import React, { useCallback, useState } from "react";
import cloudStore from "../store/CloudStore";
import { Button, FormControlLabel, Grid, MenuItem, Paper, Select, Switch, Typography } from "@material-ui/core";
import withIntl from "../utils/withIntl";
import { _post } from "../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../store/CloudActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditTextField from "../components/EditArticle/EditTextField";
import SelectArticles from "../components/Forms/SelectArticles";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import SetupUbereatsStore from "../components/Ubereats/SetupUbereatsStore";

function Ubereats(props) {
  const [ubereatsMerchant, setUbereatsMerchant] = useState(cloudStore.merchant.ubereats_merchants[0]);
  const [waitingForApiCall, setWaitingForApiCall] = useState(false);

  const loadStore= useCallback((id) => {
    loadStoreInfo({ ubereats_merchant_id: id }).then((ubereatsMerchant) => {
      setUbereatsMerchant(ubereatsMerchant);
    });
  },[setUbereatsMerchant])

  if (waitingForApiCall) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (ubereatsMerchant == null) {
    return (
      <Paper style={{ padding: 8 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant={"h6"}>Uber Eats</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ fontStyle: "italic" }}>Uber Eats integration</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant={"contained"}
              color={"primary"}
              onClick={() => {
                updateUbereatsMerchant({ merchant_id: cloudStore.merchant.id }).then((ubereatsMerchant) => {
                  ubereatsMerchant.merchant_id = cloudStore.merchant.id;
                  setUbereatsMerchant(ubereatsMerchant);
                });
              }}
            >
              Create connection
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }



  return (
    <Paper style={{ padding: 8 }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography variant={"h6"}>Uber Eats</Typography>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => {
              loadStore(ubereatsMerchant.id)
            }}
          >
            Test connection
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontStyle: "italic" }}>Uber Eats integration</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={{ fontStyle: "italic" }}>Accepting orders: </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            style={{
              fontStyle: "italic",
              color: ubereatsMerchant.accept_orders ? "lightseagreen" : "orangered",
              fontWeight: ubereatsMerchant.accept_orders ? "normal" : "800",
            }}
          >
            {ubereatsMerchant.accept_orders ? "Yes" : "No"}
          </Typography>
        </Grid>

        <AuthorizationWrapper
          permission={"ubereats.api_key"}
          child={
            <>
              <Grid item xs={6}>
                Api Key:
              </Grid>
              <Grid item xs={6}>
                <Select
                  value={ubereatsMerchant.ubereats_api_id}
                  onChange={(e) => {
                    updateUbereatsMerchant({
                      id: ubereatsMerchant.id,
                      ubereats_api_id: e.target.value,
                    }).then((ubereatsMerchant) => {
                      setUbereatsMerchant(ubereatsMerchant);
                    });
                  }}
                >
                  <MenuItem value={1}>MynOber</MenuItem>
                </Select>
              </Grid>
            </>
          }
        />

        <AuthorizationWrapper
          permission={"ubereats.eats_stores"}
          child={
            <>
              <Grid item xs={6}>
                Eats setup store
              </Grid>
              <Grid item xs={6}>
                <SetupUbereatsStore
                  handleSelect={(option) => {
                    updateUbereatsMerchant({
                      id: ubereatsMerchant.id,
                      eats_store_id: option.store_id,
                    }).then((ubereatsMerchant) => {
                      setUbereatsMerchant(ubereatsMerchant);
                      loadStore(ubereatsMerchant.id)
                    });
                  }}
                />
              </Grid>
            </>
          }
        />

        <AuthorizationWrapper
          permission={"ubereats.eats_store_id"}
          child={
            <>
              <Grid item xs={6}>
                Eats store id:
              </Grid>
              <Grid item xs={6}>
                <EditTextField
                  key={ubereatsMerchant.eats_store_id ??""}
                  value={ubereatsMerchant.eats_store_id ?? ""}
                  onBlur={(value, setBeginValue) => {
                    updateUbereatsMerchant({
                      id: ubereatsMerchant.id,
                      eats_store_id: value === "" ? null : value,
                    }).then((merchant) => {
                      setUbereatsMerchant(merchant);
                      setBeginValue(value === "" ? null : value);
                    });
                  }}
                />
              </Grid>
            </>
          }
        />

        <Grid item xs={6}>
          Uber Eats store name:
        </Grid>
        <Grid item xs={6}>
          <Typography>
            {ubereatsMerchant.eats_store_info?.name ?? "Press button to load store info and test connection"}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color={"primary"}
                checked={ubereatsMerchant.accept_orders}
                onChange={(e) => {
                  updateUbereatsMerchant({ id: ubereatsMerchant.id, accept_orders: e.target.checked }).then(
                    (ubereatsMerchant) => {
                      setUbereatsMerchant(ubereatsMerchant);
                    }
                  );
                }}
              />
            }
            label={"Accept orders"}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color={"primary"}
                checked={ubereatsMerchant.auto_confirm_orders}
                onChange={(e) => {
                  updateUbereatsMerchant({
                    id: ubereatsMerchant.id,
                    auto_confirm_orders: e.target.checked,
                  }).then((ubereatsMerchant) => {
                    setUbereatsMerchant(ubereatsMerchant);
                  });
                }}
              />
            }
            label={"Automatically confirm orders"}
          />
        </Grid>
        <Grid item xs={4}>
          {/*<FormControlLabel*/}
          {/*  control={*/}
          {/*    <Switch*/}
          {/*      color={"primary"}*/}
          {/*      checked={ubereatsMerchant.auto_close_orders}*/}
          {/*      onChange={(e) => {*/}
          {/*        updateUbereatsMerchant({*/}
          {/*          id: ubereatsMerchant.id,*/}
          {/*          auto_close_orders: e.target.checked,*/}
          {/*        }).then((ubereatsMerchant) => {*/}
          {/*          setUbereatsMerchant(ubereatsMerchant);*/}
          {/*        });*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  }*/}
          {/*  label={"Automatically close orders"}*/}
          {/*/>*/}
        </Grid>

        <Grid item xs={6}>
          Table id prefix
        </Grid>
        <Grid item xs={6}>
          <EditTextField
            value={ubereatsMerchant.table_id_prefix ?? ""}
            onBlur={(value, setBeginValue) => {
              updateUbereatsMerchant({
                id: ubereatsMerchant.id,
                table_id_prefix: value === "" ? null : value,
              }).then((merchant) => {
                setUbereatsMerchant(merchant);
                setBeginValue(value === "" ? null : value);
              });
            }}
          />
        </Grid>
        <Grid item xs={6}>
          Unknown article plu
        </Grid>
        <Grid item xs={6} container>
          <SelectArticles
            filteredOutArticles={[]}
            handleOnSelect={(article) => {
              updateUbereatsMerchant({
                id: ubereatsMerchant.id,
                unknown_article_plu: article.plu,
              }).then((merchant) => {
                setUbereatsMerchant(merchant);
              });
            }}
            label={props.intl.formatMessage({ id: "select_article" })}
            value={ubereatsMerchant.unknown_article_plu}
            helperText={props.intl.formatMessage({ id: "select_article" })}
          />
          {ubereatsMerchant.unknown_article_plu != null && (
            <Button
              variant={"outlined"}
              onClick={() => {
                updateUbereatsMerchant({
                  id: ubereatsMerchant.id,
                  unknown_article_plu: null,
                }).then((merchant) => {
                  setUbereatsMerchant(merchant);
                });
              }}
            >
              Remove plu
            </Button>
          )}
        </Grid>
        <Grid item xs={6}>
          Default vat for unlinked article (eg. 0.09 or 0.21 for respectively 9% or 21%)
        </Grid>
        <Grid item xs={6}>
          <EditTextField
            value={ubereatsMerchant.default_vat_articles ?? ""}
            onBlur={(value, setBeginValue) => {
              updateUbereatsMerchant({
                id: ubereatsMerchant.id,
                default_vat_articles: value === "" ? null : value,
              }).then((merchant) => {
                setUbereatsMerchant(merchant);
                setBeginValue(value === "" ? null : value);
              });
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

function updateUbereatsMerchant(ubereatsMerchant) {
  let data = { ...ubereatsMerchant };

  return _post(`/nova/v2/ubereats_merchants/update`, [data])
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      let updatedMerchant = { ...cloudStore.merchant };
      updatedMerchant.ubereats_merchant = res.data[0];

      setMerchant(updatedMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data[0]);
    });
}

function loadStoreInfo(ubereatsMerchant) {
  let data = { ...ubereatsMerchant };

  return _post(`/nova/v2/ubereats_merchants/load_store_info`, [data])
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      let updatedMerchant = { ...cloudStore.merchant };
      updatedMerchant.ubereats_merchant = res.data[0];

      setMerchant(updatedMerchant);
      toast.success("Connection OK", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data[0]);
    });
}

export default withIntl(Ubereats);
